import api from "@/api";

import deepClone from "@/utils/deep-clone";

const state = {
    list: [],
};

const getters = {
    list(state) {
        return deepClone(state["list"]) ?? [];
    },
};

const actions = {
    getList({ commit }, { payload: { status } }) {
        return api
            .get(
                `/api/saved-views?${
                    status?.length ? "&status[]=" + status.join("&status[]=") : ""
                }`,
            )
            .then(res => {
                const list = res?.data;
                if (list && Array.isArray(list)) {
                    commit("updateList", {
                        list,
                    });
                }
            });
    },
    create({ dispatch }, { payload: { data } }) {
        return api.post("/api/saved-views", data).then(() => {
            return dispatch({ type: "getList", payload: { status: ["active"] } });
        });
    },
    delete({ dispatch }, { payload: { _id } }) {
        return api.delete(`/api/saved-views/${_id}`).then(() => {
            return dispatch({ type: "getList", payload: { status: ["active"] } });
        });
    },
    edit({ dispatch }, { payload: { savedView } }) {
        return api.patch(`/api/saved-views`, savedView).then(() => {
            return dispatch({ type: "getList", payload: { status: ["active"] } });
        });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
